/* eslint-disable react/jsx-props-no-spreading */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import map from 'lodash/map';

import styles from '../styles/uikitInputsRadio.module.scss';

const RadioInput = ({
  fieldId,
  fieldKey = '',
  options = [],
  label = '',
  labelPosition = 'left',
  value = null,
  updateField,
  isDisabled = false,
  isHidden = false,
  isStacked = false,
  className = '',
}) => {
  if (options?.length) {
    const onChange = (option) => {
      updateField(option.value);
    };
    return (
      <div
        className={classnames(
          styles.element,
          { [styles.isHidden]: isHidden, [styles.isStacked]: isStacked },
          className,
        )}
        role="radiogroup"
        aria-labelledby={`${fieldId}-label`}
      >
        {map(options, (option, index) => {
          const labelText = option.label;
          const id = `${fieldId}-${index}`;

          return (
            <div key={option.label} className={classnames(styles.radioItem)}>
              <input
                className={classnames(styles.input)}
                name={fieldKey}
                checked={value === option.value}
                disabled={option.isDisabled || isDisabled}
                key={option.value}
                id={id}
                type="radio"
                value={option.value === null ? '' : option.value}
                onChange={() => onChange(option)}
              />
              <label className={styles.label} htmlFor={id}>
                {labelText}
              </label>
            </div>
          );
        })}
      </div>
    );
  }

  const Element = label ? 'label' : Fragment;
  const attributes = label ? { htmlFor: fieldId, className: styles.label } : {};
  const onChange = (eTargetValue) => {
    updateField(eTargetValue);
  };
  return (
    <div className={className}>
      <Element {...attributes}>
        {labelPosition === 'left' && label}
        <input
          name={fieldKey}
          type="radio"
          value={value === null ? '' : value}
          checked={value}
          className={styles.input}
          id={fieldId}
          onChange={(e) => onChange(e.target.value)}
          disabled={isDisabled}
        />
        {labelPosition === 'right' && label}
      </Element>
    </div>
  );
};

RadioInput.propTypes = {
  label: PropTypes.string,
  labelPosition: PropTypes.string,
  fieldId: PropTypes.string.isRequired,
  fieldKey: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
      isDisabled: PropTypes.bool,
    }),
  ),
  updateField: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  isHidden: PropTypes.bool,
  isStacked: PropTypes.bool,
  className: PropTypes.string,
};

export default RadioInput;
